import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";

const Block = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading font-bold text-2xl mb-2">{title}</h2>
    <div className="font-body text-charcoal/75 space-y-2">{children}</div>
  </div>
);

export default function Terms() {
  return (
    <>
      <Seo path="/terms" title="Terms of Service" description="The simple terms for using Skedaddle Junk Removal services in the Lowcountry, SC." />
      <PageHero eyebrow="Legal" title="Terms of Service" />
      <section className="bg-white py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 md:px-8">
          <p className="font-body text-charcoal/60 mb-8">Last updated June 2026.</p>
          <Block title="Quotes">
            <p>Quotes are estimates based on the information and photos you provide. The final price is confirmed on site before we begin any work, and you approve it first.</p>
          </Block>
          <Block title="What we haul">
            <p>We remove most household and commercial items. We cannot accept hazardous chemicals, propane, ammunition, asbestos, medical waste or loose liquids. See our What We Cannot Haul page.</p>
          </Block>
          <Block title="Scheduling">
            <p>We do our best to hit every arrival window. Weather, traffic and job size can shift timing, and we will keep you posted if anything changes.</p>
          </Block>
          <Block title="Payment">
            <p>Payment is due when the job is complete. We will let you know accepted payment methods when we confirm your pickup.</p>
          </Block>
          <Block title="Contact">
            <p>Questions? Call or text us at 843-518-0021.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
